import axios from 'axios';
import type { LogContext, LogLevel, LokiPayload, LokiLabel } from './types';
import type { LoggingConfig } from './config';
import { filterMessagePII, filterPII } from './piiFilter';

export class RemoteLogTransport {
  private config: LoggingConfig;

  constructor(config: LoggingConfig) {
    this.config = config;
  }

  async send(level: LogLevel, message: string, context?: LogContext): Promise<void> {
    if (!this.config.remoteLoggingEnabled) return;

    try {
      const filteredMessage = filterMessagePII(message);
      const filteredContext = context ? filterPII(context as Record<string, unknown>) : undefined;

      const logLine = filteredContext
        ? `${filteredMessage} | ${JSON.stringify(filteredContext)}`
        : filteredMessage;

      const labels: LokiLabel = {
        app: this.config.appName.toLowerCase().replace(/\s+/g, '-'),
        environment: this.config.environment,
        level,
        ...(context?.component ? { component: String(context.component) } : {}),
      };

      const payload: LokiPayload = {
        streams: [
          {
            stream: labels,
            values: [[`${Date.now() * 1_000_000}`, logLine]],
          },
        ],
      };

      const url = `${this.config.apiBaseUrl}/${this.config.logsEndpoint.replace(/^\//, '')}`;

      await axios.post(url, payload, {
        timeout: 5000,
        headers: { 'Content-Type': 'application/json' },
      });
    } catch {
      if (this.config.isDevelopment) {
        console.error('[RemoteLogTransport] Failed to send log to backend');
      }
    }
  }
}
